import * as types from './types';

export const setUserActivationRequestLoading = (isLoading = true) => ({
  type: types.USER_ACTIVATION_SET_USER_ACTIVATION_REQUEST_LOADING,
  isLoading
});

export const sendUserActivationRequest = (email) => ({
  type: types.USER_ACTIVATION_SEND_USER_ACTIVATION_REQUEST,
  email
});

export const setUserActivationRequestHasBeenSentToEmail = (userActivationRequestHasBeenSentToEmail) => ({
  type: types.USER_ACTIVATION_SET_USER_ACTIVATION_REQUEST_HAS_BEEN_SENT_TO_EMAIL,
  userActivationRequestHasBeenSentToEmail
});

export const resetUserActivationState = () => ({
  type: types.USER_ACTIVATION_RESET_USER_ACTIVATION_STATE
});

export const setUserActivationRequestFailedReason = (userActivationRequestFailedReason) => ({
  type: types.USER_ACTIVATION_SET_USER_ACTIVATION_REQUEST_FAILED_REASON,
  userActivationRequestFailedReason
});

export const validateUserActivationCode = (code) => ({
  type: types.USER_ACTIVATION_VALIDATE_USER_ACTIVATION_CODE,
  code
});

export const activateUserByCode = (code) => ({
  type: types.USER_ACTIVATION_ACTIVATE_USER_BY_CODE,
  code
});

export const setConfirmUserActivationLoading = (isLoading = true) => ({
  type: types.USER_ACTIVATION_SET_CONFIRM_USER_ACTIVATION_LOADING,
  isLoading
});

export const setUserActivationWorkflowState = (workflowState) => ({
  type: types.USER_ACTIVATION_SET_USER_ACTIVATION_WORKFLOW_STATE,
  workflowState
});

export const resetConfirmUserActivationState = () => ({
  type: types.USER_ACTIVATION_RESET_CONFIRM_USER_ACTIVATION_STATE
});

export const setUserActivationRequestFailedCode = (userActivationRequestFailedCode) => ({
  type: types.USER_ACTIVATION_SET_USER_ACTIVATION_REQUEST_FAILED_CODE,
  userActivationRequestFailedCode
});

export const setUserActivationIdForRedirect = (applicationId) => ({
  type: types.USER_ACTIVATION_SET_USER_APPLICATION_ID_FOR_REDIRECT,
  applicationId
});

export const fetchUserApplicationIdForRedirect = () => ({
  type: types.USER_ACTIVATION_FETCH_USER_APPLICATION_ID_FOR_REDIRECT
});


// WEBPACK FOOTER //
// ./src/actions/user-activation/index.js